import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Reviews() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Delve into in-depth train reviews on First-Class.com. Explore the world of luxury train travel, featuring top-notch services, routes, and experiences'
          }
        />
        <title>Train Reviews: Honest Assessments of Train Journeys</title>
      </Head>
      <ArticlesList subtype="Reviews" type="Trains" />
    </>
  );
}

export default withLayout(Reviews, true);
